import React, { useState } from 'react';

import { ListFieldSection, PageSection } from '../Layout';
import { Field, Message, NumericInput } from '../Core';
import InterfaceConnectionButtons from '../Equipment/Interfacing/InterfaceConnectionButtons';
import { FormatTypes } from '../../Lib/Format';

const serialOptions: SerialOptions = { baudRate: 9600, parity: 'none', dataBits: 8, stopBits: 1 };
const getDriver = () => ({
  Id: 'fake-driver',
  Data: {
    Name: 'Fake Driver',
    EquipmentType: {
      Id: 30005,
      Name: 'Balance',
      EquipmentType: 'Balance',
    },
    Request: 'REQUEST',
    Regex: 'START([\\d\\.]+)END',
  },
});

const getEquipmentModel = (equipmentId: string) => ({
  Id: equipmentId,
  Code: 'Test Equipment',
  Driver: getDriver(),
  PortSettings: {
    BaudRate: serialOptions.baudRate,
    Parity: serialOptions.parity,
    DataBits: serialOptions.dataBits,
    StopBits: serialOptions.stopBits,
    IsValidPortSettings: true,
  },
});

const FakeField: React.FC<{ equipmentId: string; label: string }> = ({ equipmentId, label }) => {
  const [value, setValue] = useState<number | undefined>();
  let equipment = getEquipmentModel(equipmentId);

  equipment.Driver.Data.Request = equipment.Driver.Data.Request.concat('-', label);

  return (
    <Field
      format={{ type: FormatTypes.AsEntered }}
      input={<NumericInput />}
      label={label}
      onChange={(event: any) => setValue(event.data?.value)}
      value={value}
      name={undefined}
      measuredUsing={equipment}
    />
  );
};

const InterfacingTest: React.FC = () => {
  return (
    <>
      <Message severity="info">
        This page is for testing the interaction of events as you tab between interfacing fields - without needing to
        set up any equipment or drivers.
        <br />
        <br />
        Connections A and B can be connected to the same or different ports.
        <br />
        <br />
        Values are matched with hard-coded regex {getDriver().Data.Regex}.
        <br />
        <br />
        Connections are made with hard-coded port settings ({serialOptions.baudRate},{serialOptions.parity},
        {serialOptions.dataBits},{serialOptions.stopBits}).
      </Message>
      <PageSection heading="Connection A">
        <InterfaceConnectionButtons equipment={getEquipmentModel('interfacingTestPage-A')} equipmentType="balance" />
      </PageSection>
      <PageSection heading="Connection B">
        <InterfaceConnectionButtons equipment={getEquipmentModel('interfacingTestPage-B')} equipmentType="balance" />
      </PageSection>

      <PageSection heading="Test Fields">
        <ListFieldSection>
          <FakeField equipmentId={'interfacingTestPage-A'} label={'Linked to A'} />
          <FakeField equipmentId={'interfacingTestPage-B'} label={'Linked to B'} />
          <FakeField equipmentId={'interfacingTestPage-A'} label={'Linked to A'} />
          <FakeField equipmentId={'interfacingTestPage-A'} label={'Linked to A'} />
          <FakeField equipmentId={'interfacingTestPage-B'} label={'Linked to B'} />
          <FakeField equipmentId={'interfacingTestPage-B'} label={'Linked to B'} />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default InterfacingTest;
